import LoginPageError from './loginPageError.container';

export default LoginPageError;
